import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HomeService } from '../_services/home.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../_services/index';
import { MustMatch } from '../_services/formValidator.service';

@Component({
  selector: 'app-pwdreset-email',
  templateUrl: './pwdreset-email.component.html',
  styleUrls: ['./pwdreset-email.component.scss']
})

export class PwdresetEmailComponent implements OnInit {
  form: FormGroup;
  i18n: any;
  resetPwdIsFailed = false;
  successMessage: string;
  resetToken: null;
  CurrentState: any;
  IsResetFormValid = true;
  sid:string;
  newPassword:string;
  loading = false;
  submitted = false;
  password:string;
  updatePassword:string;
  conPassword:string;
  passwordNotValid = false;
  cPasswordNotValid = false;
  notMatch = false;
  buttonLabel: string;
  ValidationPattern: any;
  applyPwdPolicyForShp: any;
  passwordLength: any;
  errorMessage: any;
  constructor(private homeService: HomeService,
    private activatedRoute: ActivatedRoute,  private authService: AuthenticationService,private router: Router,private fb: FormBuilder) {
      this.form = this.fb.group(
        {
          newPassword: ['', [Validators.required,Validators.maxLength(15)]],
          
          confirmPassword: ['', [Validators.required]]},
        {
        validator:MustMatch('newPassword','confirmPassword')
      }

      );
    }

    ngOnInit() {
      const newPasswordControl = this.form.get('newPassword');
      this.homeService.getPwdPolicies().subscribe(res => {
        if(res.return_body != null || res.return_body !=undefined){
        this.ValidationPattern = res.return_body.pwdComplexity.pwdPattern;
        this.applyPwdPolicyForShp = res.return_body.pwdComplexity.applyForSHP;
        this.passwordLength = res.return_body.pwdComplexity.pwdLength;
        if(this.applyPwdPolicyForShp){
          this.errorMessage = res.return_body.pwdComplexity.errorMessage ;
          const minLength: number = this.passwordLength
          newPasswordControl.setValidators([
            Validators.required,
            Validators.maxLength(50),
            Validators.pattern(this.ValidationPattern),
            Validators.minLength(this.passwordLength),
          ]);
      }
      else
        this.defaultPwdValidation()
  }
  else
    this.defaultPwdValidation()

    newPasswordControl.updateValueAndValidity();
  });

       if (sessionStorage.getItem('i18n')) {
        this.i18n = JSON.parse(sessionStorage.getItem('i18n'));
      }
       this.sid=this.activatedRoute.snapshot.queryParamMap.get('sid');
         this.router.navigate([], { relativeTo: this.activatedRoute, replaceUrl: true });
 
         this.authService.validateResetToken(this.sid,String(this.homeService.institutionId))
             .subscribe( (res: any) =>{
               if (res.return_code == '403') {
                 alert(' Invalid Url');
               }else{
                console.log('Valid Url')
               }
             });
    }
    
    Init() {
    }
    get f() { return this.form.controls; }

   
    handleNavigation(pathValue) {
      if (pathValue) {
        this.router.navigate([this.router.url.split("/")[1], pathValue]);
      }
    }
    defaultPwdValidation(){
      this.errorMessage=this.i18n._value['shp.common.newpasswordvalidation'];
      this.form.get('newPassword').setValidators([
        Validators.required,
        Validators.minLength(6),
        Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-zd$@$!%*?&].{6,15}$")
      ]);
    }
  
     ResetPassword() {
      this.loading = true;
         this.IsResetFormValid = true;
         let formValue = this.form.controls;
         this.authService.newPassword(this.sid,formValue.newPassword.value, formValue.confirmPassword.value,String(this.homeService.institutionId))
         .subscribe(data => {
            console.log(data);
            alert(data.error_msg)
            //this.router.navigateByUrl('login');
            this.handleNavigation('login');
        },
        error => {
          this.resetPwdIsFailed = true 
          alert('The Password Reset URL has been expired... Please try again')
          this.handleNavigation('forgotPassword');
          this.homeService.sendMessage(false); 
        });
}
}